﻿// # Imports
import { Modal } from 'bootstrap.native';

export class Checkout {
    /**
    * Dynamic handling of cart actions
    * @param {HTMLElement} element Video DOM element
    */
    constructor(element) {
        // Name, reference
        element.Checkout = this;

        // Elements
        this._refs = {
            el: element
        };

        // Component mapping
        this._steps = {
            'cssConfirmBillingAndDelivery': '_onBillingAndDelivery',
            'cssOrderSummaryAndSubmit': '_onOrderSummeryAndSubmit',
            'cssOrderCompleted': '_onOrderCompleted'
        };

        const
            currentStep = this._refs.el.getAttribute('id'),
            currentStepCallback = this._steps[currentStep];
            
        // Initialize current step validation/logic
        this[currentStepCallback]();
    }

    /**
     * Validation handler for Billing and Delivery
     **/
    _onBillingAndDelivery() {
        // # Delivery Date 
        let 
            strDeliveryDateClass = '[data-modal="updatedDeliveryDate"]',
            oDeliveryDateModal = this._refs.el.querySelector(strDeliveryDateClass);

        if (oDeliveryDateModal !== null) {
            oDeliveryDateModal = new Modal(strDeliveryDateClass);
            oDeliveryDateModal.show();
        }
    }

    /**
     * Validation handler for Summary and Submit
     **/
    _onOrderSummeryAndSubmit() { }

    /**
    * Validation handler for Order Completed
    **/
    _onOrderCompleted() {}
}